// extracted by mini-css-extract-plugin
module.exports = {"ActiveQuiz":"ActiveQuiz_ActiveQuiz__3DSWl","Question":"ActiveQuiz_Question__qewwJ"};